import { MagicStructureResponseData } from './magic-structure-response-data.model';

export class MagicFormInstanceResponseData extends MagicStructureResponseData {
    public formInstanceId: number;
}
